import { Common, CommonDataInput } from './common.model';

interface FactoryDataInput extends CommonDataInput {
    name: string;
    costCenterId: string;
    tribe: string;
}

export class Factory extends Common {
    // IDs are defined.
    declare id: string;

    public name: string;
    public costCenterId: string;
    public tribe: string;

    constructor(data: FactoryDataInput) {
        super(data);
        this.name = data.name;
        this.costCenterId = data.costCenterId;
        this.tribe = data.tribe;
    }
}
